import { useEffect, useRef } from 'react'
import { useAuthorCommissioningStore } from '@/stores/useAuthorCommissioningStore'
import { CommissioningMessage } from './CommissioningMessage'
import { CommissioningThinking } from './CommissioningThinking'
import { ProposalCard } from './ProposalCard'

export function CommissioningTranscript({
  onAccept,
  acceptDisabled,
}: {
  onAccept: () => void
  acceptDisabled: boolean
}) {
  const messages = useAuthorCommissioningStore((s) => s.messages)
  const isThinking = useAuthorCommissioningStore((s) => s.isThinking)
  const isStreaming = useAuthorCommissioningStore((s) => s.isStreaming)
  const proposalText = useAuthorCommissioningStore((s) => s.proposalText)
  const endRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
  }, [messages, isThinking, proposalText])

  if (messages.length === 0 && !isStreaming) {
    return (
      <div className="author-opening">
        say what you want to learn about. one sentence is fine.
      </div>
    )
  }

  return (
    <>
      {messages.map((m) => (
        <CommissioningMessage key={m.id} message={m} />
      ))}
      {isThinking && <CommissioningThinking />}
      <ProposalCard onAccept={onAccept} disabled={acceptDisabled} />
      <div ref={endRef} />
    </>
  )
}
